import classNames from "classnames"
import { forwardRef, PropsWithChildren } from "react"
import styles from "./FlexRow.module.scss"

interface IFlexRowProps {
    className?: string
    wrap?: boolean
}

const FlexRow = forwardRef<HTMLDivElement, PropsWithChildren<IFlexRowProps>>((props, ref) => {
    return (
        <div className={classNames(props.className, styles.root, props.wrap && styles.wrap)}
            ref={ref}
        >
            {props.children}
        </div>
    )
})

export default FlexRow
